const API_URL = process.env.REACT_APP_API_URL;

export async function ec2Get(path) {
  const res = await fetch(`${API_URL}/prod/ec2proxy`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ method: 'GET', path }),
  });
  const data = await res.json();
  return typeof data.body === 'string' ? JSON.parse(data.body) : data.body || data;
}

export async function ec2Post(path, payload) {
  const res = await fetch(`${API_URL}/prod/ec2proxy`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ method: 'POST', path, data: payload }),
  });
  const data = await res.json();
  return typeof data.body === 'string' ? JSON.parse(data.body) : data.body || data;
}

export async function ec2Delete(path, payload) {
  const res = await fetch(`${API_URL}/prod/ec2proxy`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ method: 'DELETE', path, data: payload }),
  });
  const data = await res.json();
  return typeof data.body === 'string' ? JSON.parse(data.body) : data.body || data;
}
